import attributeAdd from "../../Main/actions/attribute/attribute-add";
import attributeGet from "../../Main/actions/attribute/attribute-get";
import attributeRemove from "../../Main/actions/attribute/attribute-remove";
import attributeReplace from "../../Main/actions/attribute/attribute-replace";
import attributeSet from "../../Main/actions/attribute/attribute-set";
import attributeToggle from "../../Main/actions/attribute/attribute-toggle";
import boundsGet from "../../Main/actions/bounds/bounds-get";
import classAdd from "../../Main/actions/class/class-add";
import classRemove from "../../Main/actions/class/class-remove";
import classToggle from "../../Main/actions/class/class-toggle";
import lengthGet from "../../Main/actions/length/length-get";

/**
 * "Action" attributes
 * @example `add(class <name: active>)`
 * @type {ActionProps}
 */
export const G_actions = new Map();

G_actions.set(
  "add",
  new Map([
    ["attribute", attributeAdd],
    ["class", classAdd],
  ])
);

G_actions.set(
  "remove",
  new Map([
    ["attribute", attributeRemove],
    ["class", classRemove],
  ])
);

G_actions.set(
  "toggle",
  new Map([
    ["attribute", attributeToggle],
    ["class", classToggle],
  ])
);

G_actions.set(
  "replace",
  new Map([
    ["attribute", attributeReplace],
  ])
);

G_actions.set(
  "get",
  new Map([
    ["height", boundsGet],
    ["width", boundsGet],
    ["top", boundsGet],
    ["right", boundsGet],
    ["bottom", boundsGet],
    ["left", boundsGet],
    ["offset-top", boundsGet],
    ["offset-bottom", boundsGet],
    ["offset-left", boundsGet],
    ["offset-right", boundsGet],
    ["attribute", attributeGet],
  ])
);

/** @type {Map<String, any>} */ (G_actions.get("get")).set("length", lengthGet);

G_actions.set("set", new Map([["attribute", attributeSet]]));
